/* eslint-disable no-unused-vars */
import React, { Component } from "react";
import { Field, reduxForm, change } from 'redux-form';
import { connect } from 'react-redux';

import Grid from '@material-ui/core/Grid';
import { TextField } from "@material-ui/core";
import { getCommunityById} from '../../actions/communityActions'

import FasCheckCircle from "../../assets/svgs/solid/checkCircle";
import { UpdateCommuny, UptOnlyRepairsEmail} from '../../actions/communityActions';
import moment from 'moment-timezone';
import { Launch } from "@material-ui/icons";

const validate = (values) => {
    let errors={};
    return errors;
};


class UptRepairsEmailComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    //#region Methods
    componentDidMount = () =>{
       this.GetCommunityData();
    }

    componentDidUpdate(prevProps){
        if(prevProps.communityId!==this.props.communityId){
            this.GetCommunityData();
        }
    }

    GetCommunityData = async() =>{
        try{
            const communityId = localStorage.getItem('communityId');

            const communityDetails =  await this.props.getCommunityById(communityId) 
    
            const firstCommunity = (communityDetails && communityDetails.length > 0)? communityDetails[0]: undefined;
    
            this.setState({communityData: firstCommunity})
            if(firstCommunity){
                this.setState({repairRecipient: firstCommunity.repairRecipient})
            }else{
                this.setState({repairRecipient: undefined})
            }
        }catch(err){
            return undefined
        }
    }

    updateEmailHandler = async () =>{
        try{
            const newRepairEmail = (this.state.repairRecipient && this.state.repairRecipient.length > 0)?this.state.repairRecipient : undefined ;
            const arrayRecipientEmails = newRepairEmail.split(';');
            const validEmails = [];

            for(let i = 0; i< arrayRecipientEmails.length; i++){
                let currentEmail = arrayRecipientEmails[i];
                currentEmail = currentEmail.trim();
                const isValidRepairEmail = await this.validateEmail(currentEmail);    

                if(isValidRepairEmail && currentEmail && currentEmail.length > 0){
                    validEmails.push(currentEmail);
                }
            }

            if(!validEmails || validEmails.length === 0)
                return undefined
            
            const repairEmailsJoined = validEmails.join(';');

            const communityId = localStorage.getItem('communityId')? localStorage.getItem('communityId') : undefined;

            // let newCommunityData = this.state.communityData;
            // const timeZoneName = newCommunityData.timeZoneName? newCommunityData.timeZoneName : 'America/New_York' ;
            // let breakObj = newCommunityData.mealsTime.find(m => m.mealType ===1)
            // let lunchObj = newCommunityData.mealsTime.find(m => m.mealType ===2)
            // let dinnerObj = newCommunityData.mealsTime.find(m => m.mealType ===3)

            // let sTime = undefined;
            // let eTime  = undefined;
            // if(breakObj){
            //     sTime = moment.tz(breakObj.timeStart, timeZoneName);
            //     const bsDateTime = `${sTime.format('YYYY-MM-DD')}T${sTime.format('HH:mm')}:00.000Z`
            //     newCommunityData.bsDateTime= bsDateTime;

            //     eTime = moment.tz(breakObj.timeEnd, timeZoneName);
            //     const beDateTime = `${eTime.format('YYYY-MM-DD')}T${eTime.format('HH:mm')}:00.000Z`
            //     newCommunityData.beDateTime= beDateTime;
            // }

            // if(lunchObj){                    
            //     sTime = moment.tz(lunchObj.timeStart, timeZoneName);
            //     const bsDateTime = `${sTime.format('YYYY-MM-DD')}T${sTime.format('HH:mm')}:00.000Z`
            //     newCommunityData.lsDateTime= bsDateTime;

            //     eTime = moment.tz(lunchObj.timeEnd, timeZoneName);
            //     const beDateTime = `${eTime.format('YYYY-MM-DD')}T${eTime.format('HH:mm')}:00.000Z`
            //     newCommunityData.leDateTime= beDateTime;
            // }

            // if(dinnerObj){     
            //     sTime = moment.tz(dinnerObj.timeStart, timeZoneName);
            //     const bsDateTime = `${sTime.format('YYYY-MM-DD')}T${sTime.format('HH:mm')}:00.000Z`
            //     newCommunityData.dsDateTime= bsDateTime;

            //     eTime = moment.tz(dinnerObj.timeEnd, timeZoneName);
            //     const beDateTime = `${eTime.format('YYYY-MM-DD')}T${eTime.format('HH:mm')}:00.000Z`
            //     newCommunityData.deDateTime= beDateTime;
            // }
            
            // const _idCommunity = newCommunityData._id;
            // delete newCommunityData._id ;

            // newCommunityData.repairRecipient = repairEmailsJoined;

            // if(this.props.UpdateCommuny && communityId){
                //     this.props.UpdateCommuny(_idCommunity, newCommunityData, stylesObj);
                // }
                
            const stylesObj = {modalStyles:{backgroundColor: '#ffffff'}, messageClass:'LAlertMessageStyles'};
            if(this.props.UptOnlyRepairsEmail){
                this.props.UptOnlyRepairsEmail(communityId, repairEmailsJoined, stylesObj);
            }

            this.GetCommunityData()

            setTimeout(() => {
                this.GetCommunityData()
            }, 1000);
        }catch(err){
            return undefined
        }
    }

    validateEmail = (email) =>{
        try{

            if(!email || email.length ===0)
                return undefined

                const pattern = '^([a-zA-Z0-9.]+)@([a-zA-Z0-9]+).([a-zA-Z0-9]{2,4})$';

                const globalRegex = new RegExp(pattern, 'g');
                const res = globalRegex.test(email);

                return res;
        }catch(err){
            return undefined;
        }
    }

    //#endregion

    //#region Components
    EmailComponent = () =>{
        return(
            <Grid item container>
                <Grid item container>
                    Repairs Notifications Emails
                </Grid>
                <Grid item container xs={11}>
                    <TextField
                        id='updateRepairsEmailInput'
                        name='updateRepairsEmailInput'
                        placeholder='Work order email'
                        value={this.state.repairRecipient}
                        fullWidth
                        InputProps={{}}
                        inputProps={{
                            className:'txt_black'
                        }}
                        className="LUptRepairEmailComponent"
                        onChange={(e) => this.setState({ repairRecipient: e.target.value })}
                        onKeyDown={(e) => { if (e && e.keyCode === 13) this.updateEmailHandler() }}
                    />
                </Grid>
                <Grid item container xs={1} justifyContent='center' alignContent="center">
                    <Grid item onClick={() => this.updateEmailHandler()}>
                        <FasCheckCircle
                            className ='LCheckCircle'
                        />
                    </Grid>
                </Grid>
            </Grid>
        )
    }
    //#endregion
   
    render() {      
        return (
            <Grid item container xs={12} justifyContent='flex-start' alignContent='center' style={{paddingLeft:'15px'}}>
                <Grid item container xs={6} md={4}>
                    <this.EmailComponent/>
                </Grid>
            </Grid>
        );
    }
}

function mapStateToProps(state, ownProps) {

    return {};
}

export default connect(mapStateToProps,{getCommunityById, UpdateCommuny, UptOnlyRepairsEmail})(reduxForm({
    form: 'UptRepairsEmailComponentForm',
})(UptRepairsEmailComponent));





